import axios from 'axios';
import { apiGatewayConfig } from './config'; // Adjust the import path as necessary
import { oktaEnabled } from './config';
import { NJToastService } from '@engie-group/fluid-design-system-react';

export async function invokeLambda(oktaAuth, endpoint, payload, userInfo) {

    var token = undefined;
    // Read token from local storage if okta is disabled
    if (!oktaEnabled) {
        token = localStorage.getItem('force-token') || undefined;
    }

    // Get OKTA token
    if (oktaEnabled) {
        // Get access token 
        token = await oktaAuth.getOrRenewAccessToken();
    }



    const url = `${apiGatewayConfig.apiBaseUrl}/${endpoint}`;
    try {
        const response = await axios.post(url, { ...payload }, token ? {
            headers: {
                Authorization: `Bearer ${token}` // Include the token in the request headers
            }
        } : null);
        if (response.data) {
            return response.data;
        }
    } catch (error) {
        console.error(`Error invoking ${url}:`, error);
        if (error.code == "ERR_NETWORK") {
            // Delay for 1 second to avoid spamming the server with requests in case of network issues
            console.warn('Network error occurred, retrying after a short delay...');
            await new Promise(resolve => setTimeout(resolve, 1000));
        }
        throw error;
    }
}

export async function getValidOktaToken(oktaAuth) {
    if (oktaEnabled) {
        const token = await oktaAuth.getOrRenewAccessToken();
        return token;
    } else {
        return '';
    }
}

export function displayNetworkError(error) {
    let title = 'Network Error occurred';
    let message = error.message || 'An unexpected error occurred. Please try again later.';
    if (error.status === 503)
        message = 'The service maybe overloaded or temporarily unavailable. Please try again later.';
    NJToastService(message, { title: title, iconName: 'error', shouldDismiss: true, dismissAfter: 5000 });
}

